export const parksJson = [
  {
    name: "Anasazi State Park Museum",
    abbr: "UTANAS",
    image: "anasazi.png",
    site: "https://stateparks.utah.gov/parks/anasazi/",
    plate: true,
    meta: "Purchase a day-use pass to Anasazi State Park Museum to explore one of the largest ancestral Puebloan villages west of the Colorado River.",
    description:
      "Anasazi State Park Museum in Boulder, Utah (approximately 248 miles south of Salt Lake City) is home to the site of the ruins of the ancient Anasazi village also known as the Coombs Village Site. The 6-acre state park is open year-round excluding major holidays and offers a visitor center, museum, store, auditorium, and picnic areas. Visit our museum to view examples of the Anasazi pottery and other native artifacts from the village. Purchase your day-use pass for the Anasazi State Park Museum today!",
    location: "Boulder",
    type: "Day-Use Pass",
    restrooms: true,
    camping: false,
    dumpStation: false,
    dogsAllowed: false,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: false,
    museum: true,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Antelope Island State Park",
    abbr: "UTANTE",
    image: "antelope.png",
    site: "https://stateparks.utah.gov/parks/antelope-island/",
    plate: true,
    meta: "Purchase a day-use pass to Antelope Island State Park to hike, mountain bike, or horseback ride through the beautiful lake and island scenery.",
    description:
      "Antelope Island State Park provides the perfect setting to hike, mountain bike, or horseback ride through the beautiful lake and island scenery of Northern Utah. Experience the famous free-range bison that were originally brought to Antelope Island back in 1893 and have grown to a herd size of roughly 600. Pronghorn antelope, mule deer, and bighorn sheep are also inhabitants of the island. While visiting, be sure to stop by Fielding Garr'’'s first permanent resident home built-in 1848.\n\nAntelope Island State Park has 17 hiking trails, varying from easy to difficult, ensuring that all guests will find a path to see the beauty the island has to offer. It is not uncommon for visitors to spot some of the wildlife on the island while hiking, so stop by the visitor center to obtain a map of the island along with its trails.\n\nAmenities at Antelope Island State Park include a visitors center, gift shop, a public beach with restrooms and showers, Island Buffalo Grill (open seasonally), and guided e-bike tours (open seasonally).",
    location: "Syracuse",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: true,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Bear Lake State Park",
    abbr: "UTBEAR",
    image: "bear.png",
    site: "https://stateparks.utah.gov/parks/bear-lake/",
    plate: true,
    meta: "Purchase a day-use pass to Bear Lake State Park to play, boat, and fish in the aqua-blue lake water known as “The Caribbean of the Rockies”.",
    description:
      "Bear Lake State Park encompasses the 28,000-year-old Bear Lake, known for its unique green-blue color as a result of calcium carbonate suspended in the water. This “Caribbean of the Rockies” stretches 20 miles long and eight miles wide, providing the perfect environment for a day out on the boat to explore the beautiful landscape of the Bear Lake coast. If excitement is more of your style, don’t forget to grab your water skis and tubing equipment because this lake provides more than enough space to accommodate any type of boating activity.\n\nBear Lake’s shoreline is the perfect place to spend the day if a boat is not in the plans. Fishing from Cisco Beach is sure to appease any fisherman. Be sure to grab your hiking poles as well! Bloomington Lake is a 1-mile long hike leading into another beautiful lake. The Lumber Pine trail also provides scenic views of Bear Lake.\n\nBear Lake State Park is open year-round, but please check conditions as some portions of the park may be closed during winter due to snow.",
    location: "Garden City",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Camp Floyd State Park Museum",
    abbr: "UTCAMP",
    image: "camp.png",
    site: "https://stateparks.utah.gov/parks/camp-floyd/",
    plate: true,
    meta: "Purchase a day-use pass to Camp Floyd State Park Museum to visit the historical landmark where troops were stationed to stop a perceived pioneer rebellion.",
    description:
      "Things to do at Camp Floyd\nCome and see the exhibits in the commissary\nRent out a Pavilion or the School House\nOn special occasions Camp Floyd hosts concerts\nIn October attend the Ghosts of Camp Floyd event\nDecember 4th and 6th attend the Camp Floyd Christmas\n\nPark Hours\nClosed Thanksgiving, Christmas, and New Years Day\nOpen Monday through Sunday 9 AM - 5 PM\n\nAbout Camp Floyd\nCamp Floyd State Park Museum is the historical landmark where 3,500 military and civilian employees settled in 1858 as President James Buchanan expected a Pioneer rebellion, which came to be known as the Utah War. It was the largest gathering of the US military in the history of the United States at the time. Although no rebellion or war ever took place, Camp Floyd and the Utah War served to divert the attention of the nation from states’ rights and slavery towards Mormonism and polygamy. The military would eventually dismantle and demolish Camp Floyd in 1861 as the military left for the Civil War. Visit Camp Floyd State Park Museum to experience and learn more about this nationally important historic site.",
    location: "Fairfield",
    type: "Day-Use Pass",
    restrooms: true,
    camping: false,
    dumpStation: false,
    dogsAllowed: true,
    hiking: false,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: false,
    museum: true,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Coral Pink Sand Dunes State Park",
    abbr: "UTCORA",
    image: "coral.png",
    site: "https://stateparks.utah.gov/parks/coral-pink/",
    plate: true,
    meta: "Purchase a day-use pass to Coral Pink Sand Dunes State Park to visit the beautiful sea of red sand where the winds can move the mountains and hills.",
    description:
      "Don’t let the name fool you, as Coral Pink Sand Dunes State Park is a geological phenomenon involving the red sand formed thousands of years ago. These sand dunes are the product of high winds and notches between the Moquith and Moccasin mountains. As the wind passes through these mountains, the sand is deposited on the other side creating the ever changing dunes present today. Coral Pink Sand Dunes State Park is home to a diverse population of bugs, including the Coral Pink tiger beetle that can only be found in the park.\n\nCoral Pink Sand Dunes State Park is a popular destination for sand sports such as ATVs and dirtbikes with 90% of the park available for riding. All dunes in the park are open to hike or play in the sand.",
    location: "Kanab",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: false,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Dead Horse Point State Park",
    abbr: "UTDEAD",
    image: "dead.png",
    site: "https://stateparks.utah.gov/parks/dead-horse/",
    plate: true,
    meta: "Purchase a day-use pass to Dead Horse Point State Park to visit the incredible overlooks of the Colorado River and Canyonlands National Park",
    description:
      "Dead Horse Point State Park is the result of millions of years of geologic activity. Ancient bodies of water and wind have carved out the canyon while volcanic activity formed the mountains. This disparity between the deep canyons and tall mountains makes Dead Horse Point State Park the ideal destination to watch memorable golden sunrises and sunsets.\n\nDead Horse Point State Park contains eight miles of hiking trails connecting with eight different overlook points. The park's mesa-top location allows guests to access these trails easily with minimal elevation gain or loss.",
    location: "Moab",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: false,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Deer Creek State Park",
    abbr: "UTDEER",
    image: "deer.png",
    site: "https://stateparks.utah.gov/parks/deer-creek/",
    plate: true,
    meta: "Purchase a day-use pass to Deer Creek State Park to windsurf, boat, swim, and fish at the ultimate recreational reservoir just an hour away from Salt Lake City.",
    description:
      "Deer Creek State Park is home to the Deer Creek Reservoir, a roughly 3,000-acre lake that offers guests access to a variety of recreational activities such as fishing, windsurfing, boating, and swimming. Located just an hour from Salt Lake City and an hour and a half from Provo, it’s the perfect place to unwind. \n\nBe sure to bring your hiking sticks to hike along the Deer Creek Trail, an 8-mile hiking, biking, and equestrian trail along the western side of the reservoir. For those wanting to get on the water, check out Uinta Kiting, where guests can take kiteboarding lessons at the only kiteboarding school in the state. During the summer months, visit the Island Aqua Park, a floating obstacle course on the reservoir. Deer Creek State Park offers a variety of other amenities while open, so be sure to check on local conditions to have the best experience possible.",
    location: "Wallsburg",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "East Canyon State Park",
    abbr: "UTEAST",
    image: "east.png",
    site: "https://stateparks.utah.gov/parks/east-canyon/",
    plate: true,
    meta: "Purchase a day-use pass to East Canyon State Park to visit the popular fishing, boating, and camping destination in northeastern Utah.",
    description:
      "East Canyon State Park is home to the East Canyon Reservoir, popular fishing, boating, and camping destination located in northeastern Utah. Visitors will find themselves along the Mormon Pioneer Trail, the historical trail that The Donner Party took when traveling from the midwest to California in the hopes to find fertile land for their crops. The trail provided easy access for the Mormon pioneers to get to the Salt Lake valley. Now East Canyon State Park acts as a fishing and camping facility along with a historical landmark retreat for those looking to take a break from the city. Kayak, paddleboard, and canoe rentals are all available for rent at the general store.",
    location: "Morgan",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Echo State Park",
    abbr: "UTECHO",
    image: "echo.png",
    site: "https://stateparks.utah.gov/parks/echo/",
    plate: true,
    meta: "Purchase a day-use pass to Echo State Park to visit the newest state park with year round recreational activities on the reservoir such as fishing and boating.",
    description:
      "Echo State Park is the newest addition to the Utah State Park’s system, becoming the 43rd state park in 2018. Just 45 minutes from Salt Lake City, Echo State Park offers a 1,394 acre reservoir, perfect for a day out on the boat to fish for the stocked trout, walleye, and bass. The reservoir is currently not offering rentals for boats, kayaks, or paddle boards but it is an amenity that will be available in the future. If bringing a boat is not an option, relax on the beach-like area or bring your hiking sticks to discover some of the surrounding trails to get spectacular views of the reservoir. Whatever outdoor recreational activity you are seeking, Echo State Park has it.",
    location: "Coalville",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Edge Of The Cedars State Park Museum",
    abbr: "UTEDGE",
    image: "edge.png",
    site: "https://stateparks.utah.gov/parks/edge-of-the-cedars/",
    plate: true,
    meta: " Purchase a day-use pass to Edge Of The Cedars State Park Museum to visit the largest collection of Anasazi pottery on display in southeastern Utah.",
    description:
      "Edge Of The Cedars State Park Museum is an ancient village from 1,000 years ago where the Puebloan people lived. This museum acts to educate and inspire visitors about the ways of the American Indian cultures that lived in the American southwest. Walkthrough the dwellings and a kiva on the site to understand the daily life of the Puebloans who inhabited the land. Edge Of The Cedars State Park Museum offers various events, exhibits, and festivals throughout the year so be on the lookout for special events. ",
    location: "Blanding",
    type: "Day-Use Pass",
    restrooms: true,
    camping: false,
    dumpStation: false,
    dogsAllowed: false,
    hiking: false,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: false,
    museum: true,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Escalante Petrified Forest State Park",
    abbr: "UTESCA",
    image: "escalante.png",
    site: "https://stateparks.utah.gov/parks/escalante-petrified-forest/",
    plate: true,
    meta: "Purchase a day-use pass to Escalante Petrified Forest state park to explore near the petrified forest, camp out, or spend the day at the beautiful reservoir!",
    description:
      "Purchase a day-use pass to Escalante Petrified Forest Utah State Park to explore near the petrified forest, camp out, or spend the day at the reservoir! Escalante, Utah was discovered in 1872 by a man named Almon Harris Thompson. He really admired the plateaus surrounding the park and named it 'Escalante' meaning 'to escalate upwards' as they looked a lot like stairs.\n\nLater, Wide Hollow Reservoir was built to provide water to the town. This reservoir now makes for a beautiful addition to the state park. It is stocked with fish and provides for many fun activities such as boating, kayaking, fishing, and more. The reservoir also makes for some breathtaking views during one of your hikes. There are many trails and hikes that overlook the blue reservoir and add a little bit more beauty to the already amazing view.\n\nThere is so much to do at Escalante State Park, this is why it is one of Utah’s most loved state parks. These activities include things like hiking, fishing, camping, biking, kayaking, and so much more. These are perfect activities for any campout! The park has a developed campground with RV sites and a wonderful group area. The campsites are clean, and have facilities making your stay as enjoyable as possible. \n\nWhen you first get to the park, check out the petrified woods, bones, and fossils. Here you’ll be able to learn about why this is one of Utah’s great treasures. You can park your vehicle at the visitors center, the trailhead, or the campground. You are welcome to stay for the day, or you can camp in any of the campsites for as long as you choose. Either way, we are sure that you will enjoy your stay at Escalante Petrified Forest State Park in Utah!",
    location: "Escalante",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Flight Park State Recreation Area",
    abbr: "UTFLIG",
    image: "flight.png",
    site: "https://stateparks.utah.gov/parks/flight-park/",
    plate: true,
    meta: "Purchase a camping pass to Flight Park State Recreation Area to spend the night in a paraglider’s dream spot.",
    description:
      "Utah State Parks and Recreation and the Utah Hang Gliding and Paragliding Association (UHGPGA) are partnering to preserve this unique recreation area that is an excellent site for teaching and gathering experience for flyers of all levels. It is known worldwide as one of the best training sites for both paragliding and hang gliding.\n\nCamping:\nPark is open to camping on the top of the park only.  14 day stay limit within a 30 day period.  Open fires prohibited.  Please clean up after your stay and pack out what you bring in.",
    location: "Lehi",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: false,
    dogsAllowed: true,
    hiking: false,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: false,
    picnic: false,
    firepits: false,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Fred Hayes State Park at Starvation",
    abbr: "UTFRED",
    image: "fred.png",
    site: "https://stateparks.utah.gov/parks/starvation/",
    plate: true,
    meta: "Purchase a day-use pass to Fred Hayes State Park at Starvation to experience the beautiful waters of Starvation Reservoir!",
    description:
      " Fred Hayes State Park is located in Duchesne, Utah and It surrounds Starvation Reservoir. Fred Hayes State Park was originally named Starvation State Park after the reservoir but was changed to Fred Hayes State Park in 2019.\n\nThere is plenty to do here! There are 3500 acres of land surrounding the blue waters of the reservoir. Check out the campsites, go fishing, try the 3D archery range, visit the slack-line park, geocaching, boating, and just enjoying the scenery are among some of the most popular things to do. The waters of the reservoir will not disappoint in any activities you choose to participate in. Starvation Reservoir is home to the annual walleye fishing tournament as well as a well-known boating destination for enthusiasts.",
    location: "Duchesne",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: false,
    golf: false,
  },
  {
    name: "Fremont Indian State Park and Museum",
    abbr: "UTFREM",
    image: "fremont.png",
    site: "https://stateparks.utah.gov/parks/fremont-indian/",
    plate: true,
    meta: "Purchase a day-use pass to Fremont Indian State Park and Museum to experience the ancient Fremont Civilization.",
    description:
      "Fremont Indian State Park and Museum are located in Sevier, Utah. Fremont Indians left behind many petroglyphs that were finally discovered in 1983. The Fremont’s lived in central Utah from about 400 to 1350 CE.\nThere is much to do at the Fremont Indian State Park. Camping is among some is a popular attraction here. You can choose to camp in your tent or RV, or even try out a yurt, teepee, or cabin on the grounds. Campsites have great amenities such as picnic tables, showers, drinking water, RV hookups with water, sewer, and power, and much more!\nWhen you’re not at your campsite, check out the museum filled with so many ancient artifacts, petroglyphs, and pictographs. You can also actually see and go inside of Fremont Indian shelters. There are also many hiking trails that provide beautiful scenery as well as an abundance of wildlife. At night as you wind down in your campsite, be sure to look up into the sky and stargaze for a while as it is a certified International Dark Sky Park!",
    location: "Sevier",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: true,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Frontier Homestead State Park Museum",
    abbr: "UTFRON",
    image: "frontier.png",
    site: "https://stateparks.utah.gov/parks/frontier-homestead/",
    plate: true,
    meta: "Purchase a day-use pass to Frontier Homestead State Park Museum to experience the early industrial history of Southern Utah",
    description:
      "Frontier Homestead State Park Museum tells the story of development in Iron County when in the 1850s, Brigham Young sent Mormon missionaries here to mine and process iron. Museum displays include horse-drawn vehicles used from 1850 to 1920 and a collection of pioneer artifacts. An iron industry exhibit features the only known remaining artifact from the original foundry – the town bell.\n\nIn addition to the permanent collections, changing special exhibits highlight artists from the local region, as well as rarely seen artifacts from the museum’s collections. Other items of interest include several historic cabins, a large collection of horse-drawn farm equipment, and Cedar City’s oldest remaining brick home, the Hunter House.",
    location: "Cedar City",
    type: "Day-Use Pass",
    restrooms: true,
    camping: false,
    dumpStation: false,
    dogsAllowed: false,
    hiking: false,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: false,
    museum: true,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Goblin Valley State Park",
    abbr: "UTGOBL",
    image: "goblin.png",
    site: "https://stateparks.utah.gov/parks/goblin-valley/",
    plate: true,
    meta: "Purchase a day-use pass to Goblin Valley State Park to experience geologic history.",
    description:
      "Cowboys searching for cattle first discovered secluded Goblin Valley. Then in the late 1920s, Arthur Chaffin, owner/operator of the Hite Ferry, and two companions were searching for an alternative route between Green River and Caineville. They came to a vantage point about a mile west of Goblin Valley and were awed by what they saw, five buttes and a valley of strange-shaped rock formations surrounded by a wall of eroded cliffs.\n\nIn 1949, Chaffin returned to the area he called Mushroom Valley. He spent several days exploring the mysterious valley and photographing its scores of intricately eroded creatures. The area was acquired by the state of Utah and in 1964 was officially designated a state park.\n\nGoblin Valley State Park is a showcase of geologic history. Exposed cliffs reveal parallel layers of rock bared by erosion. Because of the uneven hardness of sandstone, some patches resist erosion much better than others. The softer material is removed by wind and water, leaving thousands of unique, geologic goblins. Water erosion and the smoothing action of windblown dust work together to shape the goblins.\n\nBedrock is exposed because of the thin soil and lack of vegetation. When rain does fall, there are few plant roots and little soil to capture and hold the water, which quickly disappears, in muddy streams without penetrating the bedrock.\n\nOpened to the public as a state park in 1964.\n\nPark Elevation – 5,000 feet",
    location: "Utah",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: false,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Goosenecks State Park",
    abbr: "UTGOOS",
    image: "goosenecks.png",
    site: "https://stateparks.utah.gov/parks/goosenecks/",
    plate: true,
    meta: "Purchase a day-use pass to Goosenecks State Park to experience amazing views of the San Juan River & countless activities.",
    description:
      "Goosenecks State Park is located in Mexican Hat, Utah. It was formed naturally by the San Juan River as it cut into the land and was eroded by water, wind, frost, and gravity. The river left behind this amazing feature with beautiful views. Ancestors of today’s Pueblo people who lived in the canyon tributaries of the San Juan left behind images on stone, storage structures, and remnants of small masonry communities.\n\nPopular activities include hiking, stargazing, camping, sightseeing, biking, and photography. The views elevate each of these experiences. The open skies allow for some of the best stargazing views in all of Utah.",
    location: "Mexican Hat",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: false,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: false,
    picnic: true,
    firepits: false,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Great Salt Lake State Park",
    abbr: "UTGREA",
    image: "great.png",
    site: "https://stateparks.utah.gov/parks/great-salt-lake/",
    plate: true,
    meta: "Purchase a day-use pass to Great Salt Lake State Park to experience one of the saltiest bodies of water in the world.",
    description:
      "The Great Salt Lake State Park is located in Salt Lake County and is a remnant of Lake Bonneville which was much larger and spanned 20,000 miles during the last Ice Age. The lake is anywhere from two to seven times saltier than the ocean.\n\nThere is a ton to do at the Great Salt Lake State Park. You can camp, get a boat slip and take out a sailboat or motorboat, or just enjoy the amazing views of the Great Salt Lake. The park is also a very popular place for bird watching since it is a major stop for millions of birds that migrate.\n\nSummer hours:\nThe park is open from Sunrise to Sunset \nThe visitor center and gift shop hours:\nMonday & Friday 11 AM to 7 PM\nSaturday & Sunday 9 AM to 8 PM\n\nWinter hours:\nThe park (including visitor center and gift shop) is open from 9AM to 5PM",
    location: "Magna",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: false,
    kayaking: false,
    wifi: true,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: true,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Green River State Park",
    abbr: "UTGREE",
    image: "green.png",
    site: "https://stateparks.utah.gov/parks/green-river/",
    teetime: "https://stateparks.utah.gov/golf/green-river/reserve/",
    plate: true,
    meta: "Purchase a day-use pass to Green River State Park and come relax under the cottonwood trees or play a round of 9 holes on the banks of the Green River.",
    description:
      "The Green River State Park is located in Green River, Utah. The Green River Starts in Wyoming and flows nearly 300 miles to reach Utah, where it runs another nearly 400 miles and eventually leads into Lake Powell.\n\nGreen River State Park is a great spot to start river trips through Labyrinth, and Stillwater canyons. There is plenty to do. The park features a challenging 9 hole golf course, great spots for camping, including cabins, boating, rafting/floating, hiking, ATV, mountain biking, and more! There are many species of birds here and the river is home to many different species of fish. Green River is also home to the annual Green River Melon Days Festival in September.",
    location: "Green River",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: true,
  },
  {
    name: "Gunlock State Park",
    abbr: "UTGUNL",
    image: "gunlock.png",
    site: "https://stateparks.utah.gov/parks/gunlock/",
    plate: true,
    meta: "Purchase a day-use pass to Gunlock State Park for recreational use of the reservoir and surrounding area.",
    description:
      "Gunlock State Park is located in Gunlock, Utah just outside of Saint George. The area was settled by William Haynes Hamblin, nicknamed Gunlock Will in 1857. He was an expert in guns and often repaired gunlocks which are firing mechanisms for muzzleloaders. The Gunlock Dam was built in 1970 for irrigation water and flood control.\n\nGunlock is a great place to camp, fish, kayak, and boat. The waters are calm, and not as crowded as other nearby lakes. This combined with warm summer water temperatures makes this a great destination for those interested in boating, fishing, etc. The red rocks surrounding the lake make for an amazing experience and spectacular views.",
    location: "Gunlock",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Huntington State Park",
    abbr: "UTHUNT",
    image: "huntington.png",
    site: "https://stateparks.utah.gov/parks/huntingtion/",
    plate: true,
    meta: "Purchase a day-use pass to Huntington State Park to enjoy a quiet campground or desert oasis.",
    description:
      "Huntington State Park is located in Huntington, Utah. Huntington Reservoir was built in 1966 as part of an Emery County irrigation and recreation project. It was named after three brothers; Oliver, William, and Dimick Huntington who explored this area in 1855.\n\nThe reservoir is a well-kept secret and is a popular place for locals. Because of the calm and warm waters, a park is a great place for crawdads. Catching crawdads is a popular activity among all ages. The great water conditions also make it a great place for migratory birds as well as water-skiers, boaters, and others who love warm, calm water.",
    location: "Huntington",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Hyrum State Park",
    abbr: "UTHYRU",
    image: "hyrum.png",
    site: "https://stateparks.utah.gov/parks/hyrum/",
    plate: true,
    meta: "Purchase a day-use pass to Hyrum State Park in Cache-County Utah. Come fish year-round or enjoy all the water sports Hyrum has to offer in the summer.",
    description:
      "What can you do at Hyrum?\nIn Hyrum, there are designated areas for swimming and for boating. You can also camp, fish, and utilize the picnic area! Hyrum has great facilities for showering, restrooms, fish cleaning, water & power hookups, charcoal grill, and tables.\n\nHyrum State Park Summer Hours\nThey are open from 6:00 am to 10:00 pm\nWinter Hours\nOpen from 8:00 am to 5:00 pm.\n\nClosed During Thanksgiving and Christmas.\n\nWhen visiting Hyrum State Park make sure to follow all the rules and regulations.\nVehicles must display a parking permit\nNo littering\nNo glass bottles\nVehicles must remain on pavement\nNo Parking on Grass or Beach (not even for a second or just to unload)\nPets must be on a maximum 6′ leash and picked up after\nFires in designated campground fire ring only.",
    location: "Syracuse",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Jordan River OHV State Park",
    abbr: "UTJOHV",
    image: "jordan.png",
    site: "https://stateparks.utah.gov/parks/jordan-river/",
    plate: true,
    meta: "Buy your day-use pass to Jordan River OHV State Park. There are trails for all types of riders, from beginner to advanced. Open on most weekends and Thursdays",
    description:
      "Waivers\nSign your waiver(s) before you come to save time! *We have updated our waiver system. Waivers are now only required once a calendar year. New waivers accepted after 4/25/2020 will be good until the end of December. New Waivers are located below or at the park upon arrival!\n\nJordan River OHV Season Schedule\nSAT & SUN Open 7 AM until 2 PM (Sometimes Thursday)\n\nDates and times are subject to change. Any changes will be posted on our official Jordan River OHV Facebook Page\n\nOff-highway vehicle facilities for riders of all abilities including advanced and novice motocross tracks, beginner area, and three-mile loop trail.\nEast and West tracks are for experienced riders only.\nThe vet track is for the intermediate level.\nBeginner (Beg) track is for entry-level.\n50 track is for pit bikes and 50cc bikes only.\n\nYouth Rider Requirements – Operators must be at least eight years of age and possess a valid education certificate.",
    location: "Salt Lake City",
    type: "Day-Use Pass",
    restrooms: true,
    camping: false,
    dumpStation: false,
    dogsAllowed: true,
    hiking: false,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: false,
    picnic: true,
    firepits: false,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Jordanelle State Park",
    abbr: "UTJORD",
    image: "jordanelle.png",
    site: "https://stateparks.utah.gov/parks/jordanelle/",
    plate: true,
    meta: "Jordanelle State Park has much to offer, three recreation areas on the Lake, picnicking, camping, boating, fishing, and hiking. Buy your pass ahead of time!",
    description:
      "Jordanelle is open from 8:00 am to 10:00 pm\n\nMussels\nIf your boat has recently been in contaminated water (including Lake Powell) you must clean, drain, and dry your boat or be professionally decontaminated! The dry time is 7 days in the summer. If you have been to Lake Powell or out-state-waters, and if you have a more complex boat with ballast tanks, in/outboard motors with unverified water, etc, then you must wait 30 days to dry or get professionally decontaminated regardless of the time of year. Mussels are getting into ballast tanks and sea strainers after being in Lake Powell one time.\n\nThings to do\nNot only does Jordanelle have some of the greatest boating in Utah, but it also has many other activities to offer. Check out our campsites in many locations, go swimming, go hiking, visit the picnic areas, try geocaching, and in the winter - go snowmobiling!",
    location: "Heber City",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: true,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Kodachrome Basin State Park",
    abbr: "UTKODA",
    image: "kodachrome.png",
    site: "https://stateparks.utah.gov/parks/kodachrome-basin/",
    plate: true,
    meta: "Buy your day pass to Kodachrome Basin State Park! Come hike, horseback ride, camp, or mountain bike, in the beautiful colorful rock and see the impressive arches.",
    description:
      "Kodachrome Basin State Park is open from 6:00 AM to 10:00 PM. \n\nKodachrome features 3 campgrounds:\nArch, Basin, and Bryce View.\n\nWhat to do\nIn addition to photography, hiking, horseback riding, and mountain biking, visitors should plan to visit Grand Staircase - Escalante National Monument. Grosvenor Arch, an intricate double arch located 11 miles southeast of Kodachrome Basin, is one of the state’s most impressive arches. Also, Cottonwood Canyon and the Paria River area, south of Kodachrome Basin, offer unlimited possibilities to explore.\n\nHistory\nAs soon as you see it, you will know that the name fits perfectly. Kodachrome Basin State Park, with its beautiful red rock formations and blue skies, just begs to be photographed. The National Geographic Society came up with the name, and it fits very well.\n\nWeather\nIn Southern Utah, the weather here is very unpredictable and can change in an instant. Plan ahead and be prepared for inclement weather at all times of the year.\n\nSpring: April, May, and early June can be very pleasant times of the year at Kodachrome Basin. Daytime temperatures are generally warm, but overnight temperatures can drop into the 20s. There is still a chance of snow in April and blustery winds are a possibility throughout the season.\n\nSummer: Late June, July, August, and early September are the hottest months at the park. Daytime highs are in the 90s to near 100 degrees. Nighttime temperatures are perfect for sleeping and often drop into the 50s. Summer thunderstorms are a real threat this time of year and can produce heavy downpours, extreme winds, dangerous lightning, and flash flooding.\n\nFall: Warm days and cool nights are the norms in late September and early October with daytime highs in the 70s and overnight lows in the 30s. By the middle of October, nights can get very cold. The first hints of winter are experienced in November as both daytime high temperatures and overnight lows begin to drop and snow becomes a possibility. \n\nWinter: Cold is the watchword through the winter months at the park. Daytime highs from December into March are often not much above the freezing point. Overnight lows can be well below zero. Heavy snow can occur at any time during this period, making travel and outdoor activities perilous, if not impossible.",
    location: "Cannonville",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },

  {
    name: "Lost Creek State Park",
    abbr: "UTLOST",
    image: "lost.png",
    site: "https://stateparks.utah.gov/parks/lostcreek/",
    plate: true,
    meta: "Purchase a day-use pass to Lost Creek State Park to paddle, fish, swim, or camp in the area around the reservoir.",
    description:
      "Purchase a day-use pass to Lost Creek State Park to paddle, fish, swim, or camp in the area around the reservoir.",
    location: "Croydon",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: false,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: false,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: false,
    golf: false,
  },

  {
    name: "Millsite State Park",
    abbr: "UTMILL",
    image: "millsite.png",
    site: "https://stateparks.utah.gov/parks/millsite/",
    plate: true,
    meta: "Buy a day-use pass to experience Millsite reservoir’s turquoise surface. The perfect quiet State Park to spend your time boating, camping, fishing, and OHV riding. ",
    description:
      "Millsite State Park Tips\nAsk a park ranger to point out some trails and sites that aren’t on the map. But respect the area to protect it for future generations.\nIn the spring season, the melted snow fills the San Rafael River to be high enough to float. \nYou must stop by the Grub Box for some delicious diner food.\nCheck out the golf course while you’re here too.\nBe aware of closed boat ramps due to this year’s low water levels.\nDue to extreme drought conditions, be extra careful to prevent wildfires during this current season. ",
    location: "Huntington",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Otter Creek State Park",
    abbr: "UTOTTE",
    image: "otter.png",
    site: "https://stateparks.utah.gov/parks/otter-creek/",
    plate: true,
    meta: "Buy an online pass for Otter Creek State Park. Come birding in the spring, fishing at the reservoir, or ride on the 3 ATV trails",
    description:
      "Amenities here include restrooms, showers, fire pits, access to the boat launch and trails, boat rentals, food, swimming, and more.\n\nThere are many activities and sightseeing adventures in Otter Creek. Reel in a trout or waterski the seven miles of the reservoir. Head to the backcountry trails on horseback, mountain bike, or ATV and enjoy the grandeur of nature, big open sky, and wildlife. Visitors have access to three ATV trails right from the park. Explore the Garfield County OHV and Great Western Trail systems or the internationally popular Paiute Trail System. Out-of-state riders must make sure to register their OHVs in compliance with Utah law.",

    location: "Antimony",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Palisade State Park",
    abbr: "UTPALI",
    image: "palisade.png",
    site: "https://stateparks.utah.gov/parks/palisade/",
    teetime: "https://stateparks.utah.gov/golf/palisade/teetime/",
    plate: true,
    meta: "Buy an online pass for Palisade State Park. Come play 18-holes, go camping, go swimming in the reservoir, or bring your non-motorized or electric boat.",
    description:
      "Palisade State Park is located just outside of Sterling, Utah.\n\nThe park is open year-round with no holiday closures. The golf course is open during later spring, summer, and early fall, weather permitting.\nSummer hours - 8:00 am to 10:00 pm\nWinter hours - 8:00 am to 5:00 pm\n\nThe average temperature of 76.5 degrees Fahrenheit, 1.03 inches of rain, and 0.2 inches of snowfall. \n\nThings to do in Palisade\nTent, RV, cabin, and yurt camping. Fishing, swimming, nonmotorized or electric boating. OHV trails are also accessible from the park. \n\nGas-powered boats are not allowed on the reservoir\n\nPalisade rentals are available:\nPaddle boats and Paddleboards: $15 for 1 hour, $30 for 4 hours, and $50 for all-day\nCanoes and Adult Kayaks: $10 for 1 hour, $20 for 4 hours, and $30 for all-day\nKid Kayaks: $5 for 1 hour and $15 for 4 hours\nFire Pits: $10 per night (Limited supply- on a first-come-first-serve basis)\n\nPets are allowed if on a maximum 6-foot leash\n\nWhich types of fish are in Palisade Reservoir?\nRainbow Trout, Tiger Trout, and some Cutthroat Trout.\n\nHiking Trails in Palisade are located just around the west side of the reservoir and go over the dam to the campground loop.",
    location: "Sterling",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: true,
  },
  {
    name: "Piute State Park",
    abbr: "UTPIUT",
    image: "piute.png",
    site: "https://stateparks.utah.gov/parks/piute/",
    plate: true,
    meta: "Buy an online pass for Piute State Park. Come ride in the heart of ATV country and don’t forget to bring your boat or kayak or just take a dip in the reservoir! ",
    description:
      "Piute State Park is open 24 hours a day and all year-round.\nNo holiday closures.\n\nWhat to do?\nBoating, water-skiing, jet-skiing, wakeboarding, kayaking, tubing, swimming or simply lounging on the sand.\n\nPiute offers incredible fishing opportunities whether from shore or on a boat. Game fish include rainbow, cutthroat, and brown trout, and smallmouth bass. Piute is also a great lake for water sports, including waterskiing, jet skiing, and wakeboarding. The park offers camping and picnicking on the beach, and access to the Paiute Trail System for OHV riding. No culinary water is available at Piute and camping areas are primitive.",
    location: "Junction",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: false,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: false,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Quail Creek State Park",
    abbr: "UTQUIA",
    image: "quail.png",
    site: "https://stateparks.utah.gov/parks/quail-creek/",
    plate: true,
    meta: "Buy an online pass for Quail Creek State Park, one of the greatest parks Southern Utah has to offer. Come boat, fish, camp, mountain bike, and golf in the area",
    description:
      "If you have recently visited Lake Powell, please be aware of the mussel situation. Lake Powell will provide some education/information at their boat ramps but do not always decontaminate watercraft exiting the park. If you are visiting from Sand Hollow or Gunlock then decontamination is not necessary.\nCurrently, Quail Creek State Park does not offer decontamination services within the park. But, Sand Hollow State Park, which is 6 miles away, does provide this service, free of charge. Watercraft entering Utah from the St. George Gorge must stop at the boat inspection station. If decontamination is required, they have the personnel to provide the service to all watercraft.\nALL watercraft, visiting from out-of-state or last visiting Lake Powell, that have compartments that hold any type of water (ballistic tanks, sea strainers, etc…) within the vessel will be automatically sent to Sand Hollow State Park for decontamination. Contact Sand Hollow State Park at 435-680-0715 for hours of decontamination.\nDRY TIMES: All complex boats are required to follow a 30 day time or go through a decon washing service.\nPLEASE REMEMBER: When traveling from one location to another, all watercraft must have the drain plug pulled per Utah state law. Thank you for your cooperation and support in keeping our waters Quagga free.\nDIG Paddlesports offers many types of rentals. They are located on-site by the reservoir entrance. You can rent a kayak, stand-up paddleboard, water carpet, PWCs, and much much more. The rental shop is located at the north end of the parking lot inside the park, just look for the paddleboards. We have snacks, beverages, and even sunscreen for sale.\nForget your shade tent? How about the ice? DIG will have you covered for all your lake needs. Stop by the shop to see what we have for you!",
    location: "Hurricane",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Red Fleet State Park",
    abbr: "UTREDF",
    image: "red.png",
    site: "https://stateparks.utah.gov/parks/red-fleet/",
    plate: true,
    meta: "Buy an online pass for Red Fleet State Park, one of the greatest parks Utah has to offer. Come boat, fish, camp, and hike to 200 million-year-old dinosaur tracks.",
    description:
      "Red Fleet State Park Hours:\nSummer: 6 a.m. to 10 p.m. Winter: 8 a.m. to 5 p.m.\nOpen year-round with no holiday closures.\n\nCheck out the geocaching! The hint they give is “Dinosaurs!”, good luck. \nThe following are the coordinates to its location and are listed in 3 different ways depending on your GPS.\nN 40.586246 E -109.437945 – degrees\nN 40 35.180′ E -109 26.272′ – degrees / minutes\nN40 35’10.80″ E -109 26′ 16.36″ – degrees / minutes / seconds\n\nHike to 200-million-year-old dinosaur tracks, boat, and fish on Red Fleet Reservoir, and camp or picnic in a campground overlooking a sandstone and desert landscape. In the heart of Dinosaurland, Red Fleet is a destination in itself and a great location for the discovery of the area.",
    location: "Vernal",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: false,
    golf: false,
  },
  {
    name: "Rockport State Park",
    abbr: "UTROCK",
    image: "rockport.png",
    site: "https://stateparks.utah.gov/parks/rockport/",
    plate: true,
    meta: "Purchase a day-use pass to Rockport State Park to visit an exhilarating recreational reservoir offering watersports and fishing.",
    description:
      "Rockport State Park is a beautiful recreational reservoir located 45 miles east of Salt Lake City. Popular activities on and around the reservoir include fishing, boating, watersports, hiking, and biking. During the winter months, Rockport State Park offers ice fishing and snowmobile trails. The number of recreational activities at Rockport ensures that anybody who enjoys being outdoors will find something to do here. Avid fishermen will have an incredible time catching both trout and bass that is present in the reservoir with success from the shoreline and boats. Rockport State Park offers summer entertainment for the whole family with concerts, bonfires, and more. Visit the Rockport Marina to rent boats, kayaks, and paddleboards.",

    location: "Peoa",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Sand Hollow State Park",
    abbr: "UTSAND",
    image: "sand.png",
    site: "https://stateparks.utah.gov/parks/sand-hollow/",
    plate: true,
    meta: "Purchase a day-use pass to Sand Hollow State Park. Enjoy your time ATV riding in the sand dunes or exploring the reservoir while boating or cliff jumping.",
    description:
      "Sand Hollow State Park encompasses all the aspects of what makes Southern Utah so great. This state park is one of the most visited within the Utah State Parks system, and for good reason. Visitors here have access to an incredible recreational lake that provides a spectacular setting for watersports such as water skiing and wakeboarding. The reservoir is also home to some of the best bass fishing in the state. Visitors who would rather stay on the shore have access to the breathtaking red sandy beaches that rival any ocean-front beach.\nBe sure to make time to check out the 16,000 acres of prime OHV riding. Local rental businesses ensure that anybody can experience all that Sand Hollow State Park has to offer. For the visitor looking to take it easy with a day out on the course, be sure to visit the world-renowned Sand Hollow Championship Golf Course with stunning views as you golf along the red cliffs. Sand Hollow is truly the pinnacle of recreation for the Utah Parks system.",
    location: "Hurricane",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Scofield State Park",
    abbr: "UTSCOF",
    image: "scofield.png",
    site: "https://stateparks.utah.gov/parks/scofield/",
    plate: true,
    meta: "Purchase a day-use pass to Scofield State Park to visit this trout fishing paradise and outdoor recreation destination. Located 2 hours south of Salt Lake City.",
    description:
      "Scofield State Park is truly a trout fishing paradise offering incredible cutthroat, rainbow, and tiger trout that can be caught from the shoreline or a boat on the reservoir.\nIn the winter, the lake freezes over but offers excellent ice fishing to those who can brave the cold temperatures. In the summer months, Scofield State Park transforms into a perfect weekend getaway for families who want to get out into nature.\nWith plenty of nearby trails, ATV riders are encouraged to bring their toys and venture into the mountain area. The relaxing environment of Scofield State Park makes it an ideal destination to unwind from the stresses of life.",
    location: "Helper",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: true,
    golf: false,
  },
  {
    name: "Snow Canyon State Park",
    abbr: "UTSNOW",
    image: "snow.png",
    site: "https://stateparks.utah.gov/parks/snow-canyon/",
    plate: true,
    meta: "Purchase a day-use pass to Snow Canyon State Park to visit the beautiful red sandstone with over 38 miles of hiking trails to enjoy.",
    description:
      "Snow Canyon State Park is a breathtaking geologic phenomenon created by millions of years of wind and volcanic activity. The Navajo sandstone, a bright red soil, makes up a major part of the park’s environment and creates an amazing area for visitors to hike through with over 38 miles of trails to choose from. Snow Canyon State Park is encompassed in the Red Cliffs Desert Reserve, a 62,000 acre federally protected land established to protect the desert tortoise and its habitat. The stunning natural landscape of the park has likely been in use by humans for thousands of years by mammoth hunters, but more recently in modern culture by appearing in films such as Butch Cassidy and the Sundance Kid and The Electric Horseman. Visit Snow Canyon State Park today to experience some of the best geologic landscape that southern Utah has to offer.",

    location: "Ivins",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Steinaker State Park",
    abbr: "UTSTEI",
    image: "steinaker.png",
    site: "https://stateparks.utah.gov/parks/steinaker/",
    plate: true,
    meta: "Purchase a day-use pass to Steinaker State Park. Come spend your time camping, boating, swimming OHV riding, hiking, fishing, or try the new 3D archery range!",
    description:
      "What to do at Steinaker Reservoir?\nThe reservoir offers great fishing, water skiing, canoeing, kayaking, wakeboarding, and paddleboarding opportunities.  There is a nice sandy beach with vault restrooms facilities, picnic tables, and a swim dock.\nSteinaker Reservoir is one of Utah’s prime fisheries. Fish for bluegill, rainbow trout, tiger trout, largemouth bass, and an occasional brown trout. \nThe park is also a popular destination for bird watchers. Cottonwood trees along nearby Ashley Creek and around the edge of the reservoir provide roosting habitat for golden and bald eagles. Other raptors include the red-tailed hawk, osprey, and great horned owl.\nWinter months are best for viewing bald eagles near the reservoir.\nSteinaker Reservoir serves as an important migratory stopover for birds in fall and spring. Commonly observed water birds include the western grebe, mallard, cinnamon and green-winged teals, American white pelican, great blue heron, and Canada goose.\nOther common birds at Steinaker Reservoir include magpies, scrub jays, killdeer, western kingbirds, yellow warbler, mountain bluebird, quail, and turkey vultures.\n\nIf you are boating don’t forget Steinaker is currently mussel-free! Please follow the guidelines on drying and decontamination. \n\nCome check out Steinakers Geo-Caching.\nThe park has a geo-cache setup and a hint to its location is “A great view of the reservoir”.  The coordinates for its location are listed in 3 different ways for your GPS.\nN40.514902  E -109.541514 – degrees\nN40 30.894′  E -109 32.492′ – degrees / minutes\nN40 30’53.47″  E -109 32′ 29.52″ – degrees / minutes / seconds\n\nCamping Facilities\nTent and RV camping are available in the 31-site campground. Select sites have electricity and sewer hookups, and all sites include a picnic table, grill, and fire pit. Group day-use and overnight areas are available. Day-use facilities include sandy beaches, swim dock, boat ramp, courtesy docks, and fish cleaning station",
    location: "Vernal",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: false,
    offHighway: false,
    golf: false,
  },
  {
    name: "Territorial Statehouse State Park Museum",
    abbr: "UTTERR",
    image: "territorial.png",
    site: "https://stateparks.utah.gov/parks/territorial-statehouse/",
    plate: true,
    meta: "Buy a pass to visit Utah’s oldest existing governmental building. The Territorial Statehouse State Park Museum takes you into Utah’s Mormon pioneer past.",
    description:
      "Artifact collections at Territorial Statehouse reflect the stories of Utah’s Mormon pioneer past. Furniture, textiles, ceramics, tools, and a large collection of photographs of Millard County pioneers are exhibited throughout the site. \n\nThe park is open from 9 AM to 5 PM Monday - Saturday\nClosed on Thanksgiving, Christmas, and New Year's Day\n\nOn the park grounds, check out the Old rock schoolhouse and historic cabins. Inside the museum, there is much to see! The basement has Military weapons, pioneer-era tools, Native American artifacts, portraits, a jail cell, wood and stoneworking tools, a printing press. The main floor has Governor Brigham Young’s office, Presbyterian school teacher’s quarters, Governor Jon Huntsman Jr. room, musical instruments and books, pioneer-era china and pottery, textiles display. Don’t forget to stop in the Legislative hall to check out the digital tours of the attic and builders of the Statehouse, historic dance hall.",
    location: "Fillmore",
    type: "Day-Use Pass",
    restrooms: true,
    camping: false,
    dumpStation: false,
    dogsAllowed: false,
    hiking: false,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: false,
    museum: true,
    biking: false,
    offHighway: true,
    golf: false,
  },
  //   {"name":"Test Park", "abbr": "TEST", "image": "utahfield.jpg", "site": "", "plate": true, "meta":  "", "description": "description"},
  {
    name: "Utah Field House of Natural History State Park Museum",
    abbr: "UTFHNH",
    image: "utahfield.png",
    site: "https://stateparks.utah.gov/parks/utah-field-house/",
    plate: true,
    meta: "Purchase a day-use pass to the Utah Field House of Natural History Museum.  Explore the prehistoric world, dig for fossils, and check out the dinosaur garden.",
    description:
      "The Utah Field House of Natural History Museum, which includes a large rotunda, exhibit halls, classroom, theater, and garden, can be rented separately or in its entirety for public or private functions. Please inquire at the visitor information desk for cost and availability.\n\nInside the Natural History Museum come check out the free visitor center. It allows guests to get all the necessary information to fulfill their adventure in the Vernal area. Friendly and knowledgeable staff is available year-round to answer questions and help enhance your visit. Visitors can get up-to-date information about attractions, recreational opportunities, food, lodging, as well as local events.",
    location: "Vernal",
    type: "Day-Use Pass",
    restrooms: true,
    camping: false,
    dumpStation: false,
    dogsAllowed: false,
    hiking: false,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: false,
    museum: true,
    biking: false,
    offHighway: false,
    golf: false,
  },
  {
    name: "Utah Lake State Park",
    abbr: "UTULSP",
    image: "utahlake.png",
    site: "https://stateparks.utah.gov/parks/utah-lake/",
    plate: true,
    meta: "Buy a pass to Utah Lake State Park. Utah Lake is one of the largest freshwater lakes in the West and yet it lies in a very dry and arid area.",
    description:
      "Don’t forget to take care of the reservoir and decontaminate your boat. Decontaminations are on a first-come-first-served basis.  Hours of operation are daily from 10 AM to 5 PM. \n\nDrone Use:  Due to its proximity to the Provo Airport Utah Lake State Park is a no-fly zone for drones.\n\nPark Information: Known as Utah’s largest freshwater lake at roughly 148 sq. miles, Utah Lake provides a variety of recreation activities. Utah Lake State Park offers fishing access for channel catfish, walleye, white bass, black bass, and several species of panfish. With an average water temperature of 75 degrees, Utah Lake provides an excellent outlet for swimming, boating, and paddleboarding. The RV campground consists of 31 sites, complete with water and power hookups.",
    location: "Provo",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: false,
    golf: false,
  },
  {
    name: "Utahraptor State Park",
    abbr: "UTRAPT",
    image: "utahraptor.png",
    site: "https://stateparks.utah.gov/parks/utahraptor/",
    plate: true,
    meta: "Purchase a day-use pass for Utahraptor State Park and explore the many recreational activities around the area.",

    location: "Moab",
    type: "Day-Use Pass",
    restrooms: false,
    camping: true,
    dumpStation: false,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: false,
    kayaking: false,
    wifi: false,
    wheelChair: false,
    picnic: false,
    firepits: false,
    museum: false,
    biking: false,
    offHighway: false,
    golf: false,
  },
  {
    name: "Wasatch Mountain State Park",
    abbr: "UTWASA",
    image: "wasatch.png",
    site: "https://stateparks.utah.gov/parks/wasatch-mountain/",
    teetime: "https://stateparks.utah.gov/parks/wasatch-mountain/golf-courses/",
    plate: true,
    meta: "Buy a day-use pass to Wasatch Mountain State Park. Come visit any time of year. Enjoy the popular golf courses or spend time in the mountains hiking and much more.",
    description:
      "Things to do in Wasatch Mountain State Park\nThere are things to do year-round. Camp in the Pine Creek Campground, reserve a tee time at one of the four popular 18-hole golf courses or hike, bike, ATV, or horseback ride on miles of mountain trails. In winter months, ski, snowshoe, or snowmobile through the alpine terrain.\n\nRentals available\nWasatch Excursions offers both guided and solo ATV, UTV, and Snowmobile rentals. With access to the pristine 22,000 acres of Wasatch Mountain State Park, Wasatch Excursions offers a unique service filled with thrills and spectacular views. They also offer FREE SHUTTLES to and from Park City and the Heber Valley.",

    location: "Midway",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: false,
    boating: false,
    fishing: true,
    kayaking: false,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: true,
  },
  {
    name: "Willard Bay State Park",
    abbr: "UTWILL",
    image: "willard.png",
    site: "https://stateparks.utah.gov/parks/willard-bay/",
    plate: true,
    meta: "Buy a day-use pass to Willard Bay State Park. Come boat, swim, water ski, and fish on the warm waters of Willard Bay. Also, watch the nesting eagles in the winter.",
    description:
      "All about Willard Bay State Park…\n\nWillard Bay is a freshwater reservoir located 12 miles northwest of Ogden on the flood plains of the Great Salt Lake. An earth-filled dike and natural shoreline make up the 20-mile enclosures. The dike is officially named the Arthur V. Watkins Dam, for a former U.S. Senator from Utah who was essential in getting the Weber Basin Project passed through congress in 1949. The area had a need for a reservoir to store surplus water from the Ogden and Weber rivers that could later be pumped out and used on farmlands.\n\nThe design and construction of the dam were completed by the U.S. Bureau of Reclamation. The reservoir is operated by the Weber Basin Water Conservancy District and recreation activities are administered by the Utah State Parks and Recreation.\nWillard Bay State Park consists of two separate marinas next to Willard Bay. Recently renovated, the park offers state-of-the-art day-use and camping facilities, boat launch ramps, and group-use areas.",
    location: "Willard",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "Yuba State Park",
    abbr: "UTYUBA",
    image: "yuba.png",
    site: "https://stateparks.utah.gov/parks/yuba/",
    plate: true,
    meta: "Purchase a day-use pass to Yuba State Park to visit the warm water beaches, amazing campsites, and the year-round fishing opportunities Yuba has to offer. All camping is priced /per night.",
    description:
      "Yuba State Park located in central Utah offers a unique experience with many different recreational opportunities. It’s warm waters during the summer attract many different visitors and make it popular for many different water activities like boating, personal watercraft, swimming and so much more.\n\nYuba offers many different campsite options, has beaches and year-round fishing experience where one can fish for many different types of fish like the Northern Pike, Tiger Muskie, Walleye, Yellow Perch, Wiper, Trout and Catfish.",
    location: "Levan",
    type: "Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: false,
    wheelChair: false,
    picnic: true,
    firepits: true,
    museum: false,
    biking: true,
    offHighway: true,
    golf: false,
  },
  {
    name: "State Park Annual Pass",
    abbr: "PANUAL",
    image: "annual.png",
    site: "https://stateparks.utah.gov/parks/annual/",
    plate: false,
    meta: "",
    description: "description",
    location: "Utah",
    type: "Annual Day-Use Pass",
    restrooms: true,
    camping: true,
    dumpStation: true,
    dogsAllowed: true,
    hiking: true,
    swimming: true,
    boating: true,
    fishing: true,
    kayaking: true,
    wifi: true,
    wheelChair: true,
    picnic: true,
    firepits: true,
    museum: true,
    biking: true,
    offHighway: true,
    golf: true,
  },
  // {
  //   name: "Physical Annual Pass",
  //   abbr: "PANUAL",
  //   image: "",
  //   site: "https://stateparks.utah.gov/parks/annual/",
  //   plate: true,
  //   meta: "",
  //   description: "description",
  // },
  // {
  //   name: "Digital Annual Pass",
  //   abbr: "DANUAL",
  //   image: "",
  //   site: "https://stateparks.utah.gov/parks/annual/",
  //   plate: true,
  //   meta: "",
  //   description: "description",
  // },
];
